(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ch-faq-item-product-meta"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-faq-trigger]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = btn.closest('[data-faq-item]');
      var isOpen = item.classList.contains('ch-faq-item--open');
      item.classList.toggle('ch-faq-item--open', !isOpen);
      btn.setAttribute('aria-expanded', String(!isOpen));
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ch-faq-item"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-faq-trigger]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = btn.closest('[data-faq-item]');
      var isOpen = item.classList.contains('ch-faq-item--open');
      item.classList.toggle('ch-faq-item--open', !isOpen);
      btn.setAttribute('aria-expanded', String(!isOpen));
    });
  });
  } catch(e) { console.error(e); }
})();

})();
